import { Rpc } from "rpc/rpc";
import { ValueWrapper } from "rpc/ValueWrapper";


export class FeedbackRpc {

    public static send(msg: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/feedback/send", {
            value: msg
        });
    }

    private constructor() {}

}